
import { getIdToken, getUser, loginRefreshToken, setUser } from '../LoginUser'


export const UserAPICall = async (url,params) => {

  try{

    let res = await UserRequest(url,params);
    if(!res.ok){
      if(res.status == 401){
        const user = await loginRefreshToken();

        if(user && user.json){
          setUser(user.json);
          res = await UserRequest(params);
          if(!res.ok){
            console.log("Relogin & RequestError",await res.json());
            return;
          }
        }else{
          console.log("Relogin Error");
          return;
        }
      }
    }

    return await res.json();
  }catch(err){
    console.log("UserAPICall",err);
  }
}

export const UserRequest = async (url,params) => {

  const idtoken = getIdToken();

  const res = await fetch(url, {
    headers: {
      Authorization: idtoken,
      Accept: "application/json",
      "Content-Type": "application/json;charset=utf-8"
    },
    body: JSON.stringify(params),
    method: "POST",
  });

  return res;

};